import { render, staticRenderFns } from "./pubWb.vue?vue&type=template&id=a9133098&scoped=true"
import script from "./pubWb.vue?vue&type=script&lang=js"
export * from "./pubWb.vue?vue&type=script&lang=js"
import style0 from "./pubWb.vue?vue&type=style&index=0&id=a9133098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9133098",
  null
  
)

export default component.exports